import React, { Component } from 'react';

class FilterButtons extends Component {
  _handleInputChange(e) {
    this.props.selectFilter(e);
  }

  render() {
    return (
      <div className="filterbuttons__wrapper">
      	<h3>Andre valg</h3>
        <div className="filterbuttons__radio">
          <label className="flex items-center">
          <input
            type="radio"
            value="new_regulations"
            name="Nye vedtægter"
            onChange={(e) => this._handleInputChange(e)}
            checked={this.props.value === "new_regulations"}
             />
            Nye vedtægter
          </label>
        </div>
        <div className="filterbuttons__radio">
          <label className="flex items-center">
          <input
            type="radio"
            value="new_beliefs"
            name="Ændret trosgrundlag"
            onChange={(e) => this._handleInputChange(e)}
            checked={this.props.value === "new_beliefs"}
             />
            Ændret trosgrundlag
          </label>
        </div>
        <div className="filterbuttons__radio">
          <label className="flex items-center">
          <input
            type="radio"
            value="new_rituals"
            name="Nye centrale ritualer"
            onChange={(e) => this._handleInputChange(e)}
            checked={this.props.value === "new_rituals"}
             />
            Nye centrale ritualer
          </label>
        </div>
        <div className="filterbuttons__radio">
          <label className="flex items-center">
          <input
            type="radio"
            value="new_donations"
            name="Nyt regnskab og/eller oplysninger om donationer"
            onChange={(e) => this._handleInputChange(e)}
            checked={this.props.value === "new_donations"}
             />
            Nyt regnskab og/eller oplysninger om donationer
          </label>
        </div>
      </div>
    );
  }
}

export default FilterButtons;



// WEBPACK FOOTER //
// ./src/modules/common/FilterButtons.js